/**
 * Symbole der Ticket-Werkzeugleisten im 16er-Raster der me-design-Symbolsprache (viewBox 0 0 16 16, Strich 1,5,
 * `currentColor` — `symbolBauen` in me-design zeichnet `data-symbol` nur so; die Font-Awesome-Glyphen des Sprites
 * (`Icon`, eigene viewBox, gefüllt) passen dort nicht hinein).
 *
 * `SYMBOL_PLUS` steht am Hauptknopf „+ Aufgabe“ (Board und Liste): Am Telefon (Stufe 3) macht me-werkzeugleiste
 * daraus den Symbolknopf `part="hauptsymbol"` mit dem Namen im Sofort-Popup (me-design 493c8d6, Entscheid 68);
 * breiter bleibt der Textknopf. Das Kreuz ist das Plus aus „Neue Spalte“, auf die Mitte gesetzt.
 */
export const SYMBOL_PLUS = '<path d="M8 3v10M3 8h10"/>';
